import { z } from "zod";

export const postPlanSchema = z.object({
	planId: z.string(),
});
